import React from "react";
import { Container } from "react-bootstrap";
import CustomNavbarClients from "../navBarClients/CustomNavbarClients";
import ClientMenuBar from "../ClientMenuBar";
import Footer from "../Footer";
import NewestProducts from "./NewestProducts";
import stars from "assets/estrellitas.png";
import { useBreakpoints } from "hooks/useBreakPoints";
import { primaryColor } from "utils/colors";
import "./NewestProductsPage.scss";

const NewestProductsPage: React.FC = () => {
  const { isMobile } = useBreakpoints();

  return (
    <>
      <CustomNavbarClients />
      <ClientMenuBar />
      
      <Container fluid className="p-0" id="newest-products-container">
        {/* Header Section */}
        <div
          className="d-flex align-items-center justify-content-center"
          style={{ margin: "2rem 0 1rem 0" }}
        >
          {!isMobile && (
            <div
              style={{
                height: "1px",
                background: primaryColor,
                flex: 1,
                maxWidth: "30%",
                boxShadow: "2px 4px 3px rgba(0,0,0,0.6)",
              }}
            />
          )}
          <h1
            style={{
              color: "black",
              fontWeight: "bold",
              fontSize: isMobile ? "36px" : "64px",
              letterSpacing: "3%",
              display: "flex",
              alignItems: "center",
              margin: isMobile ? "0 2rem" : "0 4rem",
              textAlign: "center",
            }}
          >
            NUEVOS PRODUCTOS
          </h1>
          <img
            src={stars}
            alt="estrella"
            style={{
              width: isMobile ? "3rem" : "4rem",
              height: isMobile ? "3rem" : "4rem",
              verticalAlign: "middle",
            }}
          />
          {!isMobile && (
            <div
              style={{
                height: "1px",
                background: primaryColor,
                flex: 1,
                maxWidth: "30%",
                boxShadow: "2px 4px 3px rgba(0,0,0,0.6)",
              }}
            />
          )}
        </div>

        {/* Newest Products Section */}
        <NewestProducts from="page" />
        
        <Footer />
      </Container>
    </>
  );
};

export default NewestProductsPage;